import { render, staticRenderFns } from "./_News.vue?vue&type=template&id=747488f3&"
import script from "./_News.vue?vue&type=script&lang=js&"
export * from "./_News.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports